import { render, staticRenderFns } from "./searchFilmRecords(16.2.2&16.2.5).vue?vue&type=template&id=2862ba12&scoped=true&"
import script from "./searchFilmRecords(16.2.2&16.2.5).vue?vue&type=script&lang=js&"
export * from "./searchFilmRecords(16.2.2&16.2.5).vue?vue&type=script&lang=js&"
import style0 from "./searchFilmRecords(16.2.2&16.2.5).vue?vue&type=style&index=0&id=2862ba12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2862ba12",
  null
  
)

export default component.exports